<template>
  <v-container id="users-tables" fluid tag="section">
    <base-material-card icon="mdi-clipboard-text" title="Báo cáo ca tham vấn" class="px-5 py-3">
      <v-data-table
        :headers="headers"
        :items="reports"
        :page.sync="page"
        :loading="loading"
        loading-text="Đang tải... Vui lòng chờ"
        hide-default-footer
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-dialog v-model="dialog" max-width="600px">
              <v-card class="pa-10">
                <v-list-item-title class="headline mb-5">
                  Nội dung
                </v-list-item-title>
                <v-textarea
                  v-model="reportAnswer.content"
                  :auto-grow="true"
                  :clearable="true"
                  :counter="false"
                  :row-height="24"
                  :rows="5"
                  :single-line="true"
                  :solo="true"
                  background-color="blue lighten-4"
                />
                <div class="d-flex justify-end">
                  <v-btn :disabled="!reportAnswer.content" :loading="loading" color="blue darken-1" text @click="answer">
                    Trả lời
                  </v-btn>
                </div>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.conversation._id="{ item }">
          <a :href="`/admin/conversations/${item.conversation._id}`">{{ item.conversation._id }}</a>
        </template>
        <template v-slot:item.createdAt="{ item }">
          {{ formatDate(item.createdAt) }}
        </template>
        <template v-slot:item.answer="{ item }">
          <div v-if="item.answer">
            {{ item.answer }}
          </div>
          <v-btn v-else small :loading="loading" color="primary" @click="openDialog(item)">
            Trả lời
          </v-btn>
        </template>
      </v-data-table>
      <v-pagination
        v-model="page"
        class="mt-5"
        :circle="false"
        :disabled="false"
        :length="totalPages"
        next-icon="navigate_next"
        prev-icon="navigate_before"
        :page="page"
        :total-visible="totalPages"
        @input="goToPage"
      />
    </base-material-card>
  </v-container>
</template>

<script>
  import ReportConversationApi from '@/api/ReportConversationApi'
  export default {
    data () {
      return {
        dialog: false,
        headers: [
          {
            text: 'ID',
            align: 'start',
            sortable: false,
            value: '_id',
          },
          { text: 'Người báo cáo', value: 'user.name' },
          { text: 'ID cuộc hội thoại', value: 'conversation._id' },
          { text: 'Nội dung', value: 'content' },
          { text: 'Mô tả', value: 'description' },
          { text: 'Thời gian', value: 'createdAt' },
          { text: 'Trả lời', value: 'answer' },
        ],
        page: 1,
        totalPages: 0,
        slots: [],
        reports: [],
        loading: true,
        loadingUpdate: false,
        reportAnswer: {
          id: '',
          content: '',
        },
        itemAnswer: {},
      }
    },
    async mounted () {
      this.loadData(this.page)
    },
    methods: {
      async loadData () {
        this.loading = true
        const response = await ReportConversationApi.getAll()
        this.loading = false
        const { ok, data, headers } = response
        if (ok) {
          this.reports = data
          this.totalPages = parseInt(headers['x-total'], 10)
        }
      },

      formatDate (date) {
        return new Date(date).toLocaleString('vi')
      },

      getName (item) {
        return item.user.name
      },

      async goToPage (page) {
        this.page = page
        this.loading = true
        const response = await ReportConversationApi.getAll(page)
        this.loading = false
        const { ok, data, headers } = response
        if (ok) {
          this.reports = data
          this.totalPages = parseInt(headers['x-total'], 10)
        }
      },

      openDialog (item) {
        this.dialog = !this.dialog
        this.itemAnswer = item
        this.reportAnswer.id = item._id
      },

      async answer () {
        this.loading = true
        const response = await ReportConversationApi.answerReport(
          this.reportAnswer.id,
          {
            answer: this.reportAnswer.content,
          },
        )
        this.loading = false
        this.dialog = !this.dialog
        this.reportAnswer.content = ''

        const { ok, data } = response
        if (ok) {
          Object.assign(this.reports[this.reports.indexOf(this.itemAnswer)], {
            answer: data.answer,
          })
        } else {
          alert('Cập nhật không thành công!')
        }
      },
    },
  }
</script>
